﻿window.ukrainesaldo = function () {
    var instance = {
        updateTree: function (sender) {

            //В классе дерева прописываем идентификтор объекта каждой строки. Передаем его в правую часть. В правой части при пост обработке записываем этот id в свойство DataObjectsTree. Вешаем этот id в дата 
            // атрибут на actionLink. Запускаем этот JS код.


            //эелемент который раскрыть, передаем из контроллера (RowID)
            var el = ducument.getelementbyid(args.treerow);

            //Достаем level 
            var level = parseInt(el.getAttribute('data-level'))

            //document.querySelector('tr[data-row="id"]'
            //раскрываем дерево
            ajaxUtils.postEventFromElementWithApiResponse(el, { data: { rowid: args.treerow, level: level } });

            //Обновляем правую часть
            ajaxUtils.postEventFromElementWithApiResponse(link);


        }
        //openlevel: function (args, counter) {

        //    if (!counter) counter = 0;

        //    if (args && args[counter]) {

        //        var rowid = '[data-rowid="' + args[counter] + '"]';
        //        var el = document.querySelector(rowid)
        //        var level = parseInt(el.getAttribute('data-level'))

        //        ajaxUtils.postEventFromElementWithApiResponse(el, { data: { rowid: args[counter], level: level } }).then(function () {
        //            instance.openlevel(args, counter + 1)
        //        }
        //        );

        //    }

        //}

    }
    return instance;
}();